import styles from "../chat-bubble.module.css";
import { useUserAuthDataContext } from "@/global-context/user-auth-context";
import Image from "next/image";

export default function TextBubble({
  payload,
  timestamp,
  sender_id,
  receiverCompleteName,
  receiverPhotoUrl,
}: {
  payload: Record<string, any>;
  timestamp: number;
  sender_id: string;
  receiverCompleteName: string | undefined;
  receiverPhotoUrl: string | undefined;
}) {
  const { userData } = useUserAuthDataContext();
  const isMine = sender_id === userData.sub;
  const senderName =
    sender_id === userData.sub ? userData.complete_name : receiverCompleteName;
  const senderPhoto =
    sender_id === userData.sub ? userData.user_photo : receiverPhotoUrl;

  const formatTime = (ts: number) => {
    return new Date(ts).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };
  payload.type = "listing";

  return (
    <div className={`${styles.row} ${isMine ? styles.mine : styles.theirs}`}>
      <div className={styles.bubbleWrapper}>
        <div className={styles.infoAndTextWrapper}>
          <span className={styles.userInfo}>
            <span className={styles.userName}>{senderName}</span>
            <Image
              className={styles.avatar}
              src={senderPhoto || "/broken_image.webp"}
              width={24}
              height={24}
              alt={`${senderPhoto || "User"} profile photo`}
            />
          </span>
          <span className={styles.text}>{payload["text"] ?? ""}</span>
        </div>
        <div className={styles.messageInfo}>
          {/* {isMine && <DoneAll className={styles.checkmark} />} */}
          <span className={styles.time}>{formatTime(timestamp)}</span>
        </div>
      </div>
    </div>
  );
}
